export default __webpack_public_path__ + "static/inner-banner-5299b8ef17767451d08ba1d0ff6fee04.webp";